import { put, call } from 'redux-saga/effects'
import { transformInvoices } from '@wellbeingxltd/fe-lib/helpers'
import FinanceActions from 'store/models/finance'
import { submitToApi } from 'awsApi'
import { URL } from './endpoints'

export function* getFinance() {
    try {
        const { payload } = yield call(() => submitToApi({ path: URL.FINANCE.V3_FINANCE_INVOICES_SUPPLIER_RETRIEVE, url: URL.FINANCE.BASE }))

        const { invoicesForClients = [], licenceFeesInvoices: licenseFeesInvoices = [], summaries = [] } = payload.data // typo issue on BE side
        const { invoicesByDates, invoicesWithMonthHeadings } = transformInvoices(invoicesForClients)
        yield put(FinanceActions.getFinanceSuccess(invoicesForClients, licenseFeesInvoices, summaries, invoicesWithMonthHeadings, invoicesByDates))
    } catch (error) {
        yield put(FinanceActions.getFinanceFailure(error))
    }
}
